module.exports = __webpack_public_path__ + "img/study04.8000877f.png";